<template>
  <div>
    <v-progress-circular v-if="!goal.pivot.completed_at"
                         :color="getColor(goal.pivot.complete_value*100)"
                         style="font-size: 12px"
                         :size="40"
                         :value="goal.pivot.complete_value*100"
                         striped
    >
      <template v-if="hasProgress">
        {{ goal.progress_current || 0}} / {{ goal.progress_total || goal.value}}
      </template>
      <template v-else>
        {{ goal.pivot.complete_value * 100}}
      </template>
    </v-progress-circular>
    <v-icon :color="goal.pivot.completed_at > goal.pivot.deadline ? 'red' : 'green'" size="40" v-else>
      mdi-check-circle
    </v-icon>
  </div>
</template>

<script>
export default {
  name: "GoalProgressBar",
  props: ['goal'],
  methods: {
    getColor(percent) {
      if (percent < 50) return 'red';
      if (percent < 70) return 'blue';
      if (percent < 80) return 'dark-blue';
      else return 'green';
   }
  },
  computed: {
    hasProgress() {
      return this.goal.progress_current != null &&
          this.goal.progress_total != null;
    }
  }
}
</script>

<style scoped>

</style>
